<div class="st-admin-backdrop" *ngIf="visible$">
	<div class="st-admin-dialog" role="dialog" aria-modal="true" aria-label="Link Articles">

		<div class="st-admin-content">

			<!-- HEADER -->
			<div class="st-admin-header">
				<div class="header-left">
					<div class="title">Link Articles</div>
					<div class="subtitle">Edit the Freshdesk Article ID inline. Leave blank to unlink.</div>
				</div>

				<div class="header-right">
					<button type="button" class="btn-ghost" (click)="refresh()">
						<i class="far fa-sync"></i>
						Refresh
					</button>

					<button type="button" class="icon-btn" (click)="close()" aria-label="Close">✕</button>
				</div>
			</div>

			<!-- BODY -->
			<div class="st-admin-body">
				<div class="grid-shell">
					<dx-data-grid [dataSource]="articles$ | async" [showBorders]="false" [columnAutoWidth]="true" [rowAlternationEnabled]="true" [hoverStateEnabled]="true" height="100%" [editing]="{ mode: 'cell', allowUpdating: true }" (onRowUpdated)="onRowUpdated($event)">
						<dxi-column dataField="settingTemplateId" caption="Setting ID" [allowEditing]="false" [width]="120"></dxi-column>
						<dxi-column dataField="displayName" caption="Name" [allowEditing]="false"></dxi-column>

						<dxi-column dataField="freshdeskArticleIdsText" caption="Freshdesk Article ID(s)" dataType="string" [width]="320" [editorOptions]="{ placeholder: 'e.g. 100040403 or 100040403, 100040404' }"></dxi-column>
					</dx-data-grid>
				</div>

				<!-- FOOTER -->
				<div class="st-admin-footer">
					<button type="button" class="btn-ghost" (click)="close()">Close</button>
				</div>
			</div>

		</div>
	</div>
</div>
